import React from 'react'

export function MatchQuestion(props: any) {
    const {options} = props;

    // staticOption false filter
    let nonStaticOptions = options.filter((option: { staticOption: any; }) => option.staticOption);
    nonStaticOptions = nonStaticOptions.sort((a: { queueNo: number; }, b: {
        queueNo: number;
    }) => a.queueNo - b.queueNo);

    // Eşleşmeleri bul ve listele
    const matchedOption = (id: number) => (options.find((option: {
        queueNo: any;
        staticOption: boolean;
        trueOptionId: number
    }) => (option.trueOptionId === id && !option.staticOption)) || {});


    return (
        <div>
            {
                nonStaticOptions?.map((option: any) => {
                    return (
                        <div className={`questionOption matchOption ${option.trueOption && 'trueOption'}`}>
                            <div className={'matchItem'}>
                                <span>{option.optionName}</span>
                                <label>{option.title}</label>
                            </div>
                            <i className="fa-solid fa-arrow-right"></i>
                            <div className={'matchItem'}>
                                <span>{matchedOption(option.id).optionName}</span>
                                <label>{matchedOption(option.id).title}</label>
                            </div>
                        </div>
                    )
                })
            }
        </div>
    )
}
